import { sendGTMEvent as sendGoogleTagManagerEvent } from '@next/third-parties/google';

export const sendGTMEvent = (options: {
  event: string;
  properties: Record<string, unknown>;
}) => {
  sendGoogleTagManagerEvent({ event: undefined, properties: undefined });
  sendGoogleTagManagerEvent(options);
};
